import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'

import Banner from './components/Banner'
import PartnerLogos from './components/PartnerLogos'
import OurServices from './components/OurServices'
import Method from './components/Method'
import Stats from './components/Stats'
import Testimonials from './components/Testimonials'
import Cta from './components/Cta'

function Home() {
  useEffect(() => {
    document.title = 'Agência Dorac'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <Banner />
      <PartnerLogos />
      <OurServices />
      <Method />
      <Stats />
      <Testimonials />
      <Cta />
      <Footer />
    </main>
  )
}

export default Home
